<template>
    <div>
        <ButtonCircle v-if="typeSmall"
                      class="type-small"
                      title="Login"
                      @click="openLoginModal"
        >
            <i class="icon-user"></i>
        </ButtonCircle>
        <Button v-else @click="openLoginModal">Login</Button>

        <RegistrationModal v-if="displayRegistrationModal"
                           @openSignIn="openSignIn"
                           @forgotPassword="openForgotPasswordModal"
                           @closeModal="closeRegistrationModal"
        ></RegistrationModal>

        <LoginModal v-if="displayLoginModal"
                    @openSignUp="openSignUp"
                    @forgotPassword="openForgotPasswordModal"
                    @closeModal="closeLoginModal"
        ></LoginModal>

        <ForgotPasswordModal v-if="displayForgotPasswordModal"
                             @closeModal="closeForgotPasswordModal"
        ></ForgotPasswordModal>
    </div>
</template>

<script>
    import Button from "../../components/Button";
    import ButtonCircle from "../../components/ButtonCircle";
    import RegistrationModal from "./RegistrationModal";
    import LoginModal from "./LoginModal";
    import ForgotPasswordModal from "./ForgotPasswordModal";

    export default {
        name: "UserIsNotLogin",

        components: {
            ForgotPasswordModal,
            Button,
            ButtonCircle,
            LoginModal,
            RegistrationModal,
        },

        props: [
            'typeSmall',
        ],

        data() {
            return {
                displayRegistrationModal: false,
                displayLoginModal: false,
                displayForgotPasswordModal: false,
            }
        },

        methods: {
            openRegistrationModal() {
                this.displayRegistrationModal = true;
            },

            closeRegistrationModal() {
                this.displayRegistrationModal = false;
            },

            openLoginModal() {
                this.displayLoginModal = true;
            },

            closeLoginModal() {
                this.displayLoginModal = false;
            },

            openSignUp() {
                this.closeLoginModal();
                this.openRegistrationModal();
            },

            openSignIn() {
                this.closeRegistrationModal();
                this.openLoginModal();
            },

            openForgotPasswordModal() {
                this.closeLoginModal();
                this.closeRegistrationModal();

                this.displayForgotPasswordModal = true;
            },

            closeForgotPasswordModal() {
                this.displayForgotPasswordModal = false;
            },

        }
    }
</script>

<style scoped>
    .type-small {
        margin: 0 5px;
        border: none;
        font-size: 16px;
        color: #fff;
        background: #4155ff;
    }

    .type-small:hover {
        background: #546dff;
    }
</style>